import { render, staticRenderFns } from "./TourWizard.vue?vue&type=template&id=b551990c&scoped=true&"
import script from "./TourWizard.vue?vue&type=script&lang=js&"
export * from "./TourWizard.vue?vue&type=script&lang=js&"
import style0 from "./TourWizard.vue?vue&type=style&index=0&id=b551990c&lang=scss&scoped=true&"
import style1 from "./TourWizard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b551990c",
  null
  
)

export default component.exports